var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SrHeadline',{staticClass:"mb-6",attrs:{"level":"3","weight":"bold"}},[_vm._v(" Skippable ")]),_c('SrCheckbox',{attrs:{"label":"Creative can be skipped"},model:{value:(_vm.isSkippable),callback:function ($$v) {_vm.isSkippable=$$v},expression:"isSkippable"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }